import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { MainPageModule } from '../pages/main/main.module';
import { EditTaskPageModule } from '../pages/edit-task/edit-task.module';
import { TutorialPageModule } from '../pages/tutorial/tutorial.module';

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    // If you want to setRoot, then Add the Module here.
    MainPageModule,
    TutorialPageModule,
    EditTaskPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts